<template>
  <content-layout :title="title" :head-image="headImage" :tabs="tabs" v-model="activeTab" :spin-show="spinShow">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div class="activity-item mgui-container" slot="/office">
      <div class="filter-row">
        <div v-if="$menu.isPower('office', 'category')">
          <Button type="info" icon="md-menu" size="small" @click="storeCateModal=true;">分类管理</Button>
        </div>
        <div>

        </div>
      </div>
      <div class="storehouse-category">
        <div class="storehouse-category-item" style="position:relative" v-for="(item,ind) in storeCate" :key="ind">
          <span style="float:right">

          </span>
          <h3 style="padding-left:10px">
            <svg class="icon" aria-hidden="true" v-if="item.iconfont">
              <use :xlink:href="'#'+item.iconfont"></use>
            </svg>
            {{item.name}}
          </h3>
          <div style="padding:5px 5px 5px 10px;margin-bottom:10px"><Tag color="yellow" type="border">库存：{{item.count}}</Tag></div>
          <ButtonGroup style="margin:-6px" long>
              <Button :disabled="!$menu.isPower('office', 'edit')" icon="md-add-circle" type="default" style="background:#fff;width:87px" @click="addStore(item)" >入库</Button>
              <Button :disabled="!$menu.isPower('office', 'edit')" icon="md-remove-circle" type="default"  @click="outStore(item)" style="background:#fff;width:70px">出库</Button>
              <Button icon="md-list" :disabled="!$menu.isPower('office', 'view')" type="default" @click="storeFetch(item)" style="background:#fff;width:105px">出入库记录</Button>
          </ButtonGroup>
        </div>
      </div>
      <Modal
          v-model="storeCateModal"
          title="分类管理"
          width="500"
          :loading="inLoading">
          <ul class="store-category">
            <li v-for="(item, ind) in storeCate" :key="ind">
              <span style="float:right" v-show="cateIds.indexOf(item.id)==-1">
                <Button type="info" size="small" @click="cateIds.push(item.id)">编辑</Button>
                <Button type="error" size="small" @click="delCate(item.id)">删除</Button>
              </span>
              <span v-show="cateIds.indexOf(item.id)>=0">
                <Input v-model="item.name" style="width:100px"></Input>
                <Button type="info" icon="plus" @click="submitStoreCate(item)">确定</Button>
              </span>
              <span v-show="cateIds.indexOf(item.id)==-1"><span style="width:140px;display:inline-block">{{item.name}}</span> &nbsp;&nbsp;<Tag>库存：{{item.count}}</Tag></span>
            </li>
            <li style="text-align:center" v-show="storeCate.length==0">正在加载...</li>
          </ul>
          <ul class="store-category">
            <li v-if="cateAdd" style="border:1px solid #eee;">
              名称：<Input v-model="storeCategory.name" placeholder="请输入分类名称" style="width:100px"></Input>&nbsp;&nbsp;
              &nbsp;&nbsp;
              <Button type="info" icon="plus" @click="submitStoreCate(storeCategory)">确定</Button>
            </li>
          </ul>
          <div slot="footer">
            <Button icon="plus-round" @click="cateAdd=true">新增分类</Button>
          </div>
      </Modal>
      <Modal
          v-model="officeSuppliesModal"
          :title="inForm.type + '--入库登记'"
          width="380"
          :loading="inLoading"
          @on-ok="storeInOut('inForm')">
          <Form ref="inForm" :model="inForm" :rules="inRuleData" style="padding-left:10px" :label-width="70">
            <FormItem label="购买时间" prop="time">
              <DatePicker format="yyyy-MM-dd HH:mm" v-model="inForm.time" type="datetime" placeholder="选择时间" style="width:260px"></DatePicker>

            </FormItem>
            <FormItem label="数量" prop="number">
              <Input v-model="inForm.number" style="max-width:265px" placeholder="请输入数量"></Input>
            </FormItem>
            <FormItem label="总价" prop="money">
              <Input v-model="inForm.money" style="max-width:265px" placeholder="请输入金额"></Input>
            </FormItem>
            <FormItem label="备注">
              <Input v-model="inForm.remarks" type="textarea" placeholder="请输入备注"></Input>
            </FormItem>
          </Form>
      </Modal>
      <Modal
          v-model="officeSuppliesOutModal"
          :title="outForm.type + '--出库登记'"
          width="380"
          :loading="outLoading"
          @on-ok="storeInOut('outForm')">

          <Form ref="outForm" :model="outForm" :rules="inRuleData" style="padding-left:10px" :label-width="70">
            <FormItem label="领取人" prop="username">
              <Input v-model="outForm.username" style="max-width:265px" placeholder="请输入领取人姓名"></Input>
            </FormItem>
            <FormItem label="部门" prop="department">
              <Cascader  @on-change="departmentChange" placeholder="选择项目组" :data="$store.state.department" change-on-select></Cascader>
            </FormItem>
            <FormItem label="领取时间" prop="time">
              <DatePicker format="yyyy-MM-dd HH:mm" v-model="outForm.time" type="datetime" placeholder="选择时间" style="width:260px"></DatePicker>
            </FormItem>
            <FormItem label="数量" prop="number">
              <Input v-model="outForm.number" style="max-width:265px" placeholder="请输入数量"></Input>
            </FormItem>
            <FormItem label="备注">
              <Input v-model="outForm.remarks" type="textarea" placeholder="请输入备注"></Input>
            </FormItem>
          </Form>
      </Modal>
      <Modal
          v-model="storeListModal"
          title="出入库记录"
          width="90%"
          :loading="storeLoading">
          <div>
            <RadioGroup v-model="filterData.inOut" @on-change="filterDataChange" type="button" size="small" style="margin-bottom:10px;">
              <Radio :label="'全部'"></Radio>
              <Radio :label="'入库'"></Radio>
              <Radio :label="'出库'"></Radio>
            </RadioGroup>
            <loading :visible="results.length==0" :icon="loadIcon" :text="loadText"></loading>
            <Table ref="selection" style="width:100%" :row-class-name="rowClassName" :columns="columns" size="small" :data="results" v-if="results.length>0"></Table>
            <div class="pager" v-if="results.length>0">
              <Page :current="page.page" :total="page.total" :page-size="15" @on-change="pagerChange" show-elevator></Page>
            </div>
          </div>
      </Modal>
    </div>
    <div class="activity-item mgui-container" slot="/office/express">
      <div class="filter-row">
        <div>
          <div style="float:right">
            <Button type="info" icon="md-arrow-up" size="small" @click="expressOutModal=true">寄件登记</Button>
            <Button type="info" icon="md-arrow-down" size="small" @click="expressInModal=true">收件登记</Button>
          </div>
          <RadioGroup v-model="expressData.inOut" @on-change="expressDataChange" type="button" size="small" style="">
            <Radio :label="'全部'"></Radio>
            <Radio :label="'收件记录'"></Radio>
            <Radio :label="'寄件记录'"></Radio>
          </RadioGroup>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          姓名：<Input v-model="expressData.name" placeholder="姓名" size="small" style="width:100px" suffix="ios-search" @on-enter="expressDataChange"/>
          &nbsp;&nbsp;
          地址：<Input v-model="expressData.address" placeholder="寄件地址" size="small" style="width:100px" suffix="ios-search" @on-enter="expressDataChange"/>
          快递公司：
          <Select v-model="expressData.express" style="width:100px" size="small">
            <Option :label="exp" :value="exp" v-for="(exp, ind) in exps" :key="ind"></Option>
          </Select>
          <Button type="info" icon="ios-search" @click="expressDataChange" size="small"></Button>
        </div>
        <div>
        </div>
      </div>
      <loading :visible="expressResult.length==0" :icon="loadIcon" :text="loadText"></loading>
      <Table ref="expressSelection" class="express-table" :row-class-name="rowClassName" :columns="expressColumns" :data="expressResult" v-if="expressResult.length>0"></Table>
        <div class="pager" v-if="expressResult.length>0">
          <Page :current="expressPage.page" :total="expressPage.total" :page-size="15" @on-change="espressPagerChange" show-elevator></Page>
        </div>
      <Modal
          v-model="expressInModal"
          title="快递收件登记"
          :loading="expressLoading"
          @on-visible-change="expressModalShow"
          @on-ok="expressInOut('expressInForm')">
          <Form ref="expressInForm" :model="expressInForm" label-position="top" :rules="expressRuleData" style="padding-left:10px">
            <Row :gutter="16">
              <Col span="12">
                <FormItem label="收件人" prop="addressee">
                  <Input v-model="expressInForm.addressee" style="max-width:265px" placeholder="请输入收件人姓名"></Input>
                </FormItem>
                <FormItem label="寄件人" prop="addresser">
                  <Input v-model="expressInForm.addresser" style="max-width:265px" placeholder="请输入寄件人姓名"></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="代收件人" prop="agent_name">
                  <Input v-model="expressInForm.agent_name" style="max-width:265px" placeholder="请输入代收件人姓名"></Input>
                </FormItem>
                <FormItem label="快递单号">
                  <Input v-model="expressInForm.express_number" style="max-width:265px" placeholder="快递单号"></Input>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="快递公司" prop="express_company">
                  <Select v-model="expressInForm.express_company">
                    <Option :label="exp" :value="exp" v-for="(exp, ind) in exps" :key="ind"></Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Form>

      </Modal>
      <Modal
          v-model="expressOutModal"
          title="快递发件登记"
          :loading="expressLoading"
          @on-visible-change="expressModalShow"
          @on-ok="expressInOut('expressOutForm')">
          <Form ref="expressOutForm" :model="expressOutForm" label-position="top" :rules="expressRuleData" style="padding-left:10px">
            <Row :gutter="16">
              <Col span="12">
                <FormItem label="寄件人" prop="addresser">
                  <Input v-model="expressOutForm.addresser" placeholder="请输入收件人姓名"></Input>
                </FormItem>
                <FormItem label="付款方式" prop="payment">
                  <Select v-model="expressOutForm.payment">
                    <Option label="到付" value="到付"></Option>
                    <Option label="寄付" value="寄付"></Option>
                  </Select>
                </FormItem>
                <FormItem label="部门" prop="department">
                  <Cascader  @on-change="departmentChange" placeholder="选择项目组" :data="$store.state.department" change-on-select></Cascader>
                </FormItem>
                <FormItem label="发件事由及发件物品" prop="content">
                  <Input v-model="expressOutForm.content" type="textarea" placeholder="请输入"></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="收件人" prop="addressee">
                  <Input v-model="expressOutForm.addressee" placeholder="请输入寄件人姓名"></Input>
                </FormItem>
                <FormItem label="收件人联系方式" prop="contact">
                  <Input v-model="expressOutForm.contact" placeholder="请输入联系方式"></Input>
                </FormItem>
                <FormItem label="收件人地址" prop="address">
                  <Input v-model="expressOutForm.address" type="textarea" placeholder="请输入地址"></Input>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="16">
              <Col span="12">
                <FormItem label="快递公司" prop="express_company">
                  <Select v-model="expressOutForm.express_company">
                    <Option :label="exp" :value="exp" v-for="(exp, ind) in exps" :key="ind"></Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="快递单号">
                  <Input v-model="expressOutForm.express_number" placeholder="快递单号"></Input>
                </FormItem>
              </Col>
            </Row>
          </Form>

      </Modal>
    </div>
  </content-layout>
</template>

<script>
  import { post, fetch, del, put } from '../fetch/api'
  // import {formatDate} from '../util/filter'
  import expressView from '../components/ExpressViewComponent.vue'

  const types = ['纸巾', '打印纸', '硒鼓/墨盒', '饮用水', '物业费', '水电', '房租', '其他']
  const exps = ['顺丰速运', '百世汇通', '申通快递', '圆通速递', 'EMS', '韵达快递', '天天快递', '佳吉快递', '百世物流', '联邦快递', '德邦物流', '华强物流', '中铁物流', '中铁快运', 'E速宝', '信丰物流', '龙邦速递', '天地华宇', '快捷快递', '邮政国内小包', '黑猫宅急便', '新邦物流', '卡行天下', '安能物流', '贝海国际速递', '佳吉快运', '能达速递', '优速快递 ', '增益速递', '国通快递', '邮政小包', '中通快递', 'EMS经济快递', '德邦快递', '凡宇速递', '联昊通', '全峰快递', '全一快递', '城市100', '广东EMS', '速尔', '燕文上海', '燕文深圳', '燕文义乌', '飞远(爱彼西)配送', '宅急送']

  const checkPrice = (rule, value, callback) => {
    if (!/^([-|1-9][\d]{0,7}|0)(\.[\d]{1,10})?$/.test(value)) {
      callback(new Error('格式错误！'))
    } else {
      callback()
    }
  }

  const inForm = {cid: 0, type: '', name: '', number: '', other: '', in_out: 1, money: '', remarks: ''}
  const outForm = {cid: 0, type: '', username: '', department: '', in_out: 0, number: '', remarks: ''}
  const expressInForm = {addressee: '', addresser: '', agent_name: '', in_out: 1, express_number: '', payment: ''}
  const expressOutForm = {addresser: '', addressee: '', department: '', in_out: 0, content: '', address: '', contact: '', express_company: '', express_number: '', payment: ''}

  export default {
    name: 'CostsPage',
    components: {
      Loading: resolve => { require(['../components/LoadingComponent'], resolve) },
      // expressView,
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      return {
        filterData: {
          inOut: '全部'
        },
        expressData: {
          inOut: '全部',
          name: '',
          express: '',
          address: ''
        },
        tabs: [
          {'title': '办公日用品登记', 'key': '/office', 'visible': true},
          {'title': '快递收发登记', 'key': '/office/express', 'visible': true}
        ],
        activeTab: '/office',
        loadText: '正在加载...',
        loadIcon: 'refresh',
        loadState: false,
        title: '办公登记',
        spinShow: false,
        headImage: '/static/images/bg/money.jpeg',
        expressRuleData: {
          addresser: {required: true, message: '请输入寄件人姓名', trigger: 'change'},
          addressee: {required: true, message: '请输入收件人姓名', trigger: 'change'},
          address: {required: true, message: '请输入收件人地址', trigger: 'change'},
          contact: {required: true, message: '请输入联系方式', trigger: 'change'},
          express_company: {required: true, message: '请输入快递公司', trigger: 'change'},
          express_number: {required: true, message: '请输入快递单号', trigger: 'change'}
        },
        inRuleData: {
          time: [
            {required: true, type: 'date', message: '请选择时间', trigger: 'change'}
          ],
          money: [
            {required: true, message: '请输入金额', trigger: 'change'},
            {validator: checkPrice, trigger: 'blur'}
          ],
          number: [
            {required: true, message: '请输入数量', trigger: 'change'},
            {validator: checkPrice, trigger: 'blur'}
          ],
          type: [
            {required: true, message: '请选择类型', trigger: 'change'}
          ],
          description: []
        },
        columns: [
          {type: 'selection', width: '60px', align: 'center', size: 'small'},
          {title: '类型', width: '80px', key: 'name'},
          {title: '姓名', width: '80px', key: 'username'},
          {
            title: '数量',
            width: '80px',
            key: 'number',
            render: (h, params) => {
              return h('div', [
                h('span', (params.row.in_out === 1 ? '+' : '-') + ' ' + params.row.number)
              ])
            }
          },
          {title: '金额', width: '80px', key: 'money'},
          {title: '发生时间', key: 'time'},
          {title: '录入时间', key: 'created_at'}
          // {
          //   title: '操作',
          //   key: 'action',
          //   width: 100,
          //   align: 'center',
          //   render: (h, params) => {
          //     return h('div', [
          //       h('Button', {
          //         props: {
          //           type: 'primary',
          //           size: 'small',
          //           icon: 'edit'
          //         },
          //         style: {
          //           marginRight: '5px'
          //         },
          //         on: {
          //           click: () => {
          //             // this.show(params.index)
          //           }
          //         }
          //       }),
          //       h('Button', {
          //         props: {
          //           type: 'error',
          //           size: 'small',
          //           icon: 'trash-a'
          //         },
          //         on: {
          //           click: () => {
          //             // this.remove(params.index)
          //           }
          //         }
          //       })
          //     ])
          //   }
          // }
        ],
        exps: exps,
        inLoading: true,
        outLoading: true,
        expressLoading: true,
        storeLoading: true,
        inForm: JSON.parse(JSON.stringify(inForm)),
        outForm: JSON.parse(JSON.stringify(outForm)),
        expressInForm: JSON.parse(JSON.stringify(expressInForm)),
        expressOutForm: JSON.parse(JSON.stringify(expressOutForm)),
        types: types,
        officeTab: '全部',
        cateIds: [],
        cateAdd: false,
        storeCate: [],
        storeCategory: {
          name: '',
          iconfont: ''
        },
        currentCid: 0,
        expressResult: [],
        expressColumns: [
          {
            title: '+',
            type: 'expand',
            width: 50,
            render: (h, params) => {
              return h(expressView, {
                props: {
                  row: params.row
                }
              })
            }
          },
          // {title: '#', width: '50', key: 'id'},
          {title: '收件人', key: 'addressee'},
          {title: '寄件人', key: 'addresser'},
          {title: '付款方式', key: 'payment'},
          {title: '快递公司', key: 'express_company'},
          {
            title: '快递单号',
            width: 180,
            key: 'express_number',
            render: (h, params) => {
              return h('div', [
                h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    // width: '80px'
                  }
                }, params.row.express_number),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginLeft: '10px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '修改单号',
                        render: (h) => {
                          return h('Input', {
                            props: {
                              value: params.row.express_number,
                              autofocus: true,
                              placeholder: '请输入快递单号'
                            },
                            on: {
                              input: (val) => {
                                this.value = val
                              }
                            }
                          })
                        },
                        onOk: () => {
                          put(`console/expressNumber/${params.row.id}`, {'number': this.value}).then(res => {
                            if (res.status === 'ok') {
                              params.row.express_number = this.value
                              // this.fetchExpress()
                            }
                            this.$Message.info(res.msg)
                          })
                        }
                      })
                    }
                  }
                }, '修改')
              ])
            }
          },
          {title: '时间', key: 'updated_at'},
          {
            title: '操作',
            key: 'action',
            // width: '150px',
            align: 'right',
            render: (h, params) => {
              return h('div', [
                params.row.in_out === 1 ? h('Button', {
                  props: {
                    type: !params.row.receive_time ? 'info' : 'default',
                    size: 'small',
                    disabled: !this.$menu.isPower('office', 'expressSet')
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      put(`console/expressReceiveTime/${params.row.id}`).then(res => {
                        this.$Message.info(res.msg)
                        params.row.receive_time = res.time
                      })
                    }
                  }
                }, !params.row.receive_time ? '待领取' : '已领取') : '',
                this.$menu.isPower('office', 'expressDel') ? h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    icon: 'md-trash'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '删除确认',
                        content: '确定删除该记录吗？',
                        onOk: () => {
                          del(`console/logExpress/${params.row.id}`).then(res => {
                            this.$Message.info(res.msg)
                            this.expressResult.splice(params.index, true)
                          })
                        }
                      })
                    }
                  }
                }) : ''
              ])
            }
          }
        ],
        expressInModal: false,
        expressOutModal: false,
        storeListModal: false,
        storeCateModal: false,
        officeSuppliesModal: false,
        officeSuppliesOutModal: false,
        officeExpressModal: false,
        results: [],
        expressPage: {
          total: 0,
          page: 1
        },
        page: {
          total: 0,
          page: 1
        }
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      }
    },
    mounted () {
      if (this.$route.query.page) this.page.page = this.$route.query.page
      if (this.$route.query.inOut) this.filterData.inOut = this.$route.query.inOut
      this.fetchCategory()
      this.routeChange(this.$route)
    },
    methods: {
      rowClassName (row) {
        if (row.in_out === 1) {
          return 'in'
        } else if (row.in_out === 0) {
          return 'out'
        }
        return ''
      },
      routeChange (route) {
        let action = route.params.action
        // this.replaceRouter()
        if (action === undefined) {
          this.activeTab = '/office'
          this.fetchOfficeSupplies()
        } else if (action === 'express') {
          this.activeTab = '/office/express'
          this.fetchExpress()
        }
      },
      addStore (item) {
        this.inForm = JSON.parse(JSON.stringify(inForm))
        this.inForm.cid = item.id
        this.inForm.type = item.name
        this.officeSuppliesModal = true
      },
      outStore (item) {
        this.outForm = JSON.parse(JSON.stringify(outForm))
        this.outForm.cid = item.id
        this.outForm.type = item.name
        this.officeSuppliesOutModal = true
        this.$store.dispatch('setDepartment')
      },
      departmentChange (val, data) {
        let str = []
        for (let k in data) {
          str.push(data[k].label)
        }
        this.outForm.department = str.join('/')
        this.expressInForm.department = str.join('/')
      },
      delCate (id) {
        this.$Modal.confirm({
          title: '删除分类',
          content: '确定删除该分类吗？',
          onOk: () => {
            del(`console/storehouseCategory/${id}`).then(res => {
              this.$Message.info(res.msg)
              this.fetchCategory()
            })
          }
        })
      },
      fetchCategory () {
        fetch(`console/storehouseCategory/0`).then(res => {
          if (res.status === 'ok') {
            this.storeCate = res.result
          }
        })
      },
      submitStoreCate (item) {
        post('console/storehouseCategory', item).then(() => {
          if (item.id) {
            const index = this.cateIds.indexOf(item.id)
            this.cateIds.splice(index, 1)
          }
          this.cateAdd = false
          this.fetchCategory()
        })
      },
      filterDataChange () {
        this.fetchOfficeSupplies()
      },
      fetchOfficeSupplies () {
        let params = JSON.parse(JSON.stringify(this.filterData))
        params.page = JSON.stringify(this.page.page)
        if (params.inOut === '全部') params.inOut = '-1'
        if (params.inOut !== '-1') params.inOut = params.inOut === '出库' ? 0 : 1
        this.loadText = '正在加载...'
        this.loadState = true
        this.results = []
        fetch(`console/storehouse/${this.currentCid}`, {params: params}).then(res => {
          if (res.status === 'ok' && res.result.data.length > 0) {
            this.results = res.result.data
            // this.page.page = res.result.current_page
            this.$set(this.page, 'total', res.result.last_page - 1)
          } else {
            this.loadIcon = 'alert-circled'
            this.loadText = '暂无记录'
          }
          this.loadState = false
        }).catch(res => {
          this.loadState = false
          this.loadText = '加载失败，请重试！'
          this.$Message.error(res.msg)
        })
      },
      replaceRouter () {
        let query = JSON.parse(JSON.stringify(this.filterData))
        query.page = this.page.page
        this.$router.push({path: '/office/express', query: query})
      },
      pagerChange (page) {
        this.page.page = page
        this.fetchOfficeSupplies()
        this.replaceRouter()
      },
      espressPagerChange (page) {
        this.expressPage.page = page
        this.fetchExpress()
        // this.replaceRouter()
      },
      storeInOut (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = name === 'inForm' ? this.inForm : this.outForm
            post('console/storehouse', data).then(res => {
              this.$Message.success(res.msg)
              if (name === 'inForm') this.officeSuppliesModal = false
              if (name === 'outForm') this.officeSuppliesOutModal = false
              this.fetchOfficeSupplies()
              this.fetchCategory()
            })
          } else {
            if (name === 'inForm') this.inLoading = false
            if (name === 'outForm') this.outLoading = false
            setTimeout(() => {
              this.$nextTick(() => {
                if (name === 'inForm') this.inLoading = true
                if (name === 'outForm') this.outLoading = true
              })
            }, 2000)
          }
        })
      },
      expressInOut (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = name === 'expressInForm' ? this.expressInForm : this.expressOutForm
            post('console/express', data).then(res => {
              this.$Message.success(res.msg)
              if (name === 'expressInForm') this.expressInModal = false
              if (name === 'expressOutForm') this.expressOutModal = false
              this.fetchOfficeSupplies()
              this.fetchCategory()
            })
          } else {
            this.expressLoading = false
            setTimeout(() => {
              this.$nextTick(() => {
                this.expressLoading = true
              })
            }, 2000)
          }
        })
      },
      fetchExpress () {
        let params = JSON.parse(JSON.stringify(this.expressData))
        params.page = JSON.stringify(this.expressPage.page)
        if (params.inOut === '全部') params.inOut = '-1'
        if (params.inOut !== '-1') params.inOut = params.inOut === '收件记录' ? 1 : 0
        this.loadText = '正在加载...'
        this.loadState = true
        this.expressResult = []
        fetch('console/express/0', {params: params}).then(res => {
          if (res.status === 'ok' && res.result.data.length > 0) {
            this.expressResult = res.result.data
            // this.expressPage.page = res.result.current_page
            this.$set(this.expressPage, 'total', res.result.total)
          } else {
            this.loadIcon = 'alert-circled'
            this.loadText = '暂无记录'
          }
          this.loadState = false
        }).catch(res => {
          this.loadState = false
          this.loadText = '加载失败，请重试！'
          this.$Message.error(res.msg)
        })
      },
      storeFetch (item) {
        this.currentCid = item.id
        this.storeListModal = true
        this.fetchOfficeSupplies()
      },
      expressModalShow (val) {
        this.expressInForm = JSON.parse(JSON.stringify(expressInForm))
        this.expressOutForm = JSON.parse(JSON.stringify(expressOutForm))
        if (val) {
          this.$store.dispatch('setDepartment')
        }
      },
      expressDataChange () {
        // this.expressPage.page = val
        this.fetchExpress()
      }
    }
  }
</script>
<style>
  /* .express-table table{width:100% } */
  .ivu-table .in td{
    background-color: #f1f5f9;
  }
  .ivu-table .out td{
    background-color: #fff6f4;
  }
</style>
<style scoped>
  .storehouse-category-item{width:260px;float:left;border-radius: 6px;border:1px solid #ccc;margin:5px;padding:5px;background: #f7f7f7}
  .storehouse-category-item .icon{font-size:20px;opacity: .5}
  .store-category li{border-bottom: 1px solid #eee;padding:10px;}
  .cost-row{
    padding: 10px 0 5px;
    border-bottom:1px solid #eee
  }
</style>
